import {
  config
} from './../config';
const utils = {
  Log(param) {
    if (config.debug) {
      console.log('¯\_(ツ)_/¯', param);
    }
  },
  Warn(param) {
    if (config.debug) {
      console.warn('(づ｡◕‿‿◕｡)づ', param);
    }
  },
  Err(param) {
    if (config.debug) {
      console.error('(ノಠ益ಠ)ノ彡┻━┻', param);
    }
  },
  deviceIsMobile: undefined,
  screenDimensions: {
    'w': window.innerWidth,
    'h': window.innerHeight
  },
  isMobile() {
    utils.screenDimensions = {
      'w': window.innerWidth,
      'h': window.innerHeight
    };
    var el = document.querySelector('body');
    // utils.Log(['testing isMobile', utils.screenDimensions]);
    if (utils.screenDimensions.w <= 768) {
      utils.deviceIsMobile = true;
      window.requestAnimationFrame(function() {
        el.classList.add('is-mobile');
      });
      return true;
    } else {
      utils.deviceIsMobile = false;
      window.requestAnimationFrame(function() {
        el.classList.remove('is-mobile');
      });
      return false;
    }
  },
  autoReflower(callback) {
    // utils.Log('_utils.autoReflower start');
    var timeout, delay, calls;
    timeout = false; // holder for timeout id
    delay = 100; // delay after event is "complete" to run callback
    calls = 0; // counter for calls, uncomment it in the event listenner if you want to log performance & function calls
    // window.resize event listener + performance management + debounce function + event throttling + callback management
    window.addEventListener('resize', function() {
      window.requestAnimationFrame(function() {
        clearTimeout(timeout);
        timeout = setTimeout(function() {
          utils.isMobile();
          if (callback) {
            callback();
          }
          // calls += 1; utils.Log(['call from autoReflower : ', calls]);
        }, delay);
      });

    });
    // calls += 1; utils.Log(['call from autoReflower : ', calls]);
    utils.isMobile();
  }
};
export {
  utils
};
